import { useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '~/utils/trpc'

/** What a verdict or an approval makes stale: the status everywhere it shows, the review queue and the timeline. */
export const useInvalidateCompatibility = () => {
  const trpc = useTRPC()
  const queryClient = useQueryClient()

  return () =>
    Promise.all(
      [
        trpc.ops.compatibilityReview.pathKey(),
        trpc.ops.stationInstallations.get.pathKey(),
        trpc.ops.stationInstallations.list.pathKey(),
        trpc.ops.stationInstallations.events.list.pathKey()
      ].map((queryKey) => queryClient.invalidateQueries({ queryKey }))
    )
}
